import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const WA_LINK = "https://wa.me/554891802091?text=Ol%C3%A1,%20gostaria%20de%20informa%C3%A7%C3%B5es%20das%20m%C3%A1quinas.........";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (typeof window !== 'undefined' && (window as any).gtag_report_conversion) {
      (window as any).gtag_report_conversion(WA_LINK, true);
    } else {
      window.open(WA_LINK, '_blank');
    }
  };

  const navLinks = [
    { label: 'Home', href: '/' },
    { label: 'Produtos', href: '#stock' },
    { label: 'Sobre', href: '#sobre' },
    { label: 'Galeria', href: '#videos' },
    { label: 'Contato', href: '#contato' },
  ];

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavClick = (href: string) => {
    setMobileOpen(false);
    if (href.startsWith('#')) {
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled ? 'bg-black/95 backdrop-blur-md border-b border-white/10' : 'bg-black/95 backdrop-blur-md border-b border-white/10'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <Link to="/" onClick={scrollToTop} className="flex items-center flex-shrink-0">
          <img
            alt="SoldaGeo logo"
            className="h-[46px] w-auto object-contain brightness-0 invert"
            src="https://assets.zyrosite.com/cdn-cgi/image/format=auto,w=768,fit=crop,q=95/A0xVvobDbRIBrVE7/rapidgeo__2_-removebg-preview-reducido-d95gQJQOpJIwwOxp.png"
          />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map((link) =>
            link.href === '/' ? (
              <Link
                key={link.label}
                to={link.href}
                onClick={scrollToTop}
                className="px-4 py-2 rounded-full text-sm tracking-wider transition-all duration-200 cursor-pointer whitespace-nowrap uppercase text-white/70 hover:text-white hover:bg-white/10"
              >
                {link.label}
              </Link>
            ) : link.href.startsWith('#') ? (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="px-4 py-2 rounded-full text-sm tracking-wider transition-all duration-200 cursor-pointer whitespace-nowrap uppercase text-white/70 hover:text-white hover:bg-white/10"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                className="px-4 py-2 rounded-full text-sm tracking-wider transition-all duration-200 cursor-pointer whitespace-nowrap uppercase text-white/70 hover:text-white hover:bg-white/10"
              >
                {link.label}
              </Link>
            )
          )}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="https://www.facebook.com/share/17JUHvyQmW/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="w-8 h-8 flex items-center justify-center rounded-full transition-all cursor-pointer text-white/60 hover:text-white hover:bg-white/10"
          >
            <i className="ri-facebook-fill" />
          </a>
          <a
            href="https://www.instagram.com/soldageobrasil/"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className="w-8 h-8 flex items-center justify-center rounded-full transition-all cursor-pointer text-white/60 hover:text-white hover:bg-white/10"
          >
            <i className="ri-instagram-line" />
          </a>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer nofollow"
            onClick={handleWhatsAppClick}
            className="ml-2 flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white text-sm font-black px-4 py-2 rounded-full transition-all cursor-pointer whitespace-nowrap uppercase tracking-wide"
          >
            <i className="ri-whatsapp-line" />
            WhatsApp
          </a>
        </div>

        <button
          className="md:hidden w-9 h-9 flex items-center justify-center rounded-full cursor-pointer transition-all text-white hover:bg-white/10"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Menu"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}`} />
        </button>
      </div>

      <div
        className={`md:hidden overflow-hidden transition-all duration-300 bg-black border-t border-white/10 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="px-6 py-4 flex flex-col gap-1">
          {navLinks.map((link) =>
            link.href === '/' ? (
              <Link
                key={link.label}
                to={link.href}
                onClick={() => { setMobileOpen(false); scrollToTop(); }}
                className="text-sm text-gray-300 hover:text-green-400 py-2.5 border-b border-white/10 cursor-pointer uppercase tracking-wide"
              >
                {link.label}
              </Link>
            ) : link.href.startsWith('#') ? (
              <a
                key={link.label}
                href={link.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(link.href); }}
                className="text-sm text-gray-300 hover:text-green-400 py-2.5 border-b border-white/10 cursor-pointer uppercase tracking-wide"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.href}
                onClick={() => setMobileOpen(false)}
                className="text-sm text-gray-300 hover:text-green-400 py-2.5 border-b border-white/10 cursor-pointer uppercase tracking-wide"
              >
                {link.label}
              </Link>
            )
          )}
          <a
            href={WA_LINK}
            target="_blank"
            rel="nofollow noreferrer"
            onClick={handleWhatsAppClick}
            className="mt-3 flex items-center justify-center gap-2 bg-green-500 text-white text-sm px-4 py-3 rounded-full cursor-pointer whitespace-nowrap"
          >
            <i className="ri-whatsapp-line" />
            Falar no WhatsApp
          </a>
        </div>
      </div>
    </header>
  );
}